/**
 * @generated SignedSource<<3c8f10100f0b62cddf8e4740fb45980c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ForgotPasswordMutation$variables = {
  email: string;
  workspaceSlug?: string | null | undefined;
};
export type ForgotPasswordMutation$data = {
  readonly resetPassword: boolean | null | undefined;
};
export type ForgotPasswordMutation = {
  response: ForgotPasswordMutation$data;
  variables: ForgotPasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "workspaceSlug",
        "variableName": "workspaceSlug"
      }
    ],
    "kind": "ScalarField",
    "name": "resetPassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForgotPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0dfb3c2d1c01833e6544f58249706da9",
    "id": null,
    "metadata": {},
    "name": "ForgotPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ForgotPasswordMutation(\n  $email: String!\n  $workspaceSlug: String\n) {\n  resetPassword(email: $email, workspaceSlug: $workspaceSlug)\n}\n"
  }
};
})();

(node as any).hash = "19ad81e3e51a9b915624c9fd3e3154b8";

export default node;
